module.exports = __webpack_public_path__ + "img/warning_yellow.4cd55298.svg";